import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, IApiCall } from '@core/services/api.service';
import { ShellQuery } from '@shared/store/shell/shell-query';
import { take, switchMap } from 'rxjs/operators';
import { HostPlatformService } from './host-platform.service';
import { EntitiesByLabIdDto } from '@shared/models/entities-by-lab-id-dto';

@Injectable({ providedIn: 'root' })
export class CustomRxApiService {
	constructor(
		private apiService: ApiService,
		private shellQuery: ShellQuery,
		private hostPlatformService: HostPlatformService
	) {}
	getAllEntitiesByLabIds(labIds: readonly number[]): Observable<EntitiesByLabIdDto[]> {
		return this.shellQuery.rxappBffUrl$.pipe(
			take(1),
			switchMap(bffUrl => {
				// Scanner (Rx via Standard Launch) must be provided with a regional rx-app-bff endpoint.
				// Web platforms already pass rxappBffUrl as the default endpoint.
				if (!bffUrl && this.hostPlatformService.isScanner) {
					throw new Error('Rx App BFF URL is not initialized');
				}

				const lang = this.shellQuery.languageCode;
				const doctorId = this.shellQuery.contactId;
				const config: IApiCall = {
					selector: 'getAllCustomRxEntitiesByLabs',
					queryParams: {
						labId: labIds,
						...(lang ? { langCode: lang } : {})
					},
					baseUrl: bffUrl ?? undefined,
					options: {
						headers: {
							// eslint-disable-next-line @typescript-eslint/naming-convention
							...(doctorId ? { 'X-Doctor-ID': String(doctorId) } : {})
						}
					}
				};

				return this.apiService.request(config);
			})
		);
	}
}
